import React from 'react';

import { PaywallAINumberStyles } from './AINumber.styles';

export const PaywallAINumber: React.FC = () => {
  return (
    <PaywallAINumberStyles>
      <div className="paywall-ai-number-wrapper">
        <img
          src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding-white/ai-number.png"
          alt="ai-number"
        />
      </div>
    </PaywallAINumberStyles>
  );
};
